export enum ApiTabsKeys {
  METRICS = "METRICS",
  COMPANIES = "COMPANIES",
  PLUGIN_USERS = "PLUGIN_USERS",
  INVITATIONS = "INVITATIONS",
}

export const DEFAULT_API_TAB_KEY = ApiTabsKeys.METRICS;
